import { ApiError } from '../lib/api.js';
import { useI18n } from '../i18n/LanguageProvider.js';

/**
 * A failed request, said in words rather than left as a blank panel.
 *
 * This existed twice — privately in the Comments panel and again in the Source
 * panel — and the two had drifted: one showed the operator hint the API sends
 * with a refusal, the other dropped it. Whichever screen you happened to be on
 * decided whether you were told *why*.
 *
 * The version that keeps the hint is the right one, so that is the one here.
 */
export function ErrorNotice({ error }: { error: unknown }) {
  const { t } = useI18n();

  const message = error instanceof ApiError ? error.message : t('common.requestFailed');
  const hint = error instanceof ApiError ? error.hint : undefined;

  return (
    <div className="notice error">
      <div>
        <p style={{ margin: 0 }}>{message}</p>
        {hint && (
          <p className="muted small" style={{ margin: '6px 0 0' }}>
            {hint}
          </p>
        )}
      </div>
    </div>
  );
}
